import setSpoolModalOpen from "@iewccouk/Store/Handlers/Custom/CustomSetSpoolModal";
import { CustomState } from "@iewccouk/Store/Reducers";
import { colorStrings, mediaQueriesBP } from "@iewccouk/Utilities/variables";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import siteMessage from "@insite/client-framework/SiteMessage";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: InventoryResultsModalStyles;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: CustomState) => {
    return {
        isOpen: state.customSpoolModal.isOpen,
        id: state.customSpoolModal.id,
    };
};

const mapDispatchToProps = {
    setSpoolModalOpen,
};

export interface InventoryResultsModalStyles {
    modal?: ModalPresentationProps;
}

export const inventoryResultsModalStyles: InventoryResultsModalStyles = {
    modal: {
        size: 600,
        // sizeVariant: "medium",
        cssOverrides: {
            modalContainer: css`
                padding: 0 15px;

                ${mediaQueriesBP.minLG} {
                    padding: 0;
                }
            `,
            modalBody: css`
                max-height: 400px;
                background-color: ${getColor(colorStrings.commonGlobalWhite)};
                overflow-y: hidden;
            `,
            modalTitle: css`
                padding: 10px 20px;
            `,
            modalContent: css`
                padding: 20px;
                max-height: 440px;
                overflow-y: auto;

                &&&& .cartLine-validation + .cartLine-validation {
                    padding-top: 15px;
                    border-top: 1px solid ${getColor("common.border")};
                }

                ${mediaQueriesBP.minLG} {
                    padding: 20px 50px 10px !important;
                }
            `,
        },
    },
};

export const LastUpdatedListIdCookieName = "LastUpdatedListId";

const SpoolModal = ({ isOpen, id, setSpoolModalOpen, extendedStyles }: Props) => {
    const [styles] = useState(() => mergeToNew(inventoryResultsModalStyles, extendedStyles));
    const [title, setTitle] = useState(siteMessage("SpoolModal_TitleMessage"));
    const [description, setDescription] = useState(siteMessage("SpoolModal_ContentMessage"));

    const modalCloseHandler = () => {
        setSpoolModalOpen({ isOpen: false });
    };

    useEffect(() => {
        if (id === "order-history") {
            setTitle(siteMessage("SpoolModal_TitleMessage_OrderHistory"));
            setDescription(siteMessage("SpoolModal_ContentMessage_OrderHistory"));
        }else if(id === "line-already-in-cart"){
            setTitle(siteMessage("SpoolModal_TitleMessage"));
            setDescription(siteMessage("SpoolModal_ContentMessage"));
        }else if(id === "order-already-in-cart"){
            setTitle(siteMessage("SpoolModal_TitleMessage_OrderAlreadyInCart","Order"));
            setDescription(siteMessage("SpoolModal_ContentMessage_OrderAlreadyInCart","order"));
        }else if(id === "list-already-in-cart"){
            setTitle(siteMessage("SpoolModal_TitleMessage_OrderAlreadyInCart","List"));
            setDescription(siteMessage("SpoolModal_ContentMessage_OrderAlreadyInCart","list"));
        }else if(id === "order-some-items-already-in-cart"){
            setTitle(siteMessage("SpoolModal_TitleMessage_OrderSomeItemsAlreadyInCart","Order"));
            setDescription(siteMessage("SpoolModal_ContentMessage_OrderSomeItemsAlreadyInCart","order"));
        }else if(id === "list-some-items-already-in-cart"){
            setTitle(siteMessage("SpoolModal_TitleMessage_OrderSomeItemsAlreadyInCart","List"));
            setDescription(siteMessage("SpoolModal_ContentMessage_OrderSomeItemsAlreadyInCart","list"));
        }
    }, [id]);

    return (
        <Modal
            {...styles.modal}
            isOpen={isOpen}
            handleClose={modalCloseHandler}
            headline={title}
            isCloseable
            contentLabel="spool modal"
        >
            <Typography variant="p">{description}</Typography>
        </Modal>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SpoolModal as any);
